import React from "react";
import {StyledWebsiteBuilders} from "./WebsiteBuilders.style";
import TemplateCard from "./TemplateCard";
import landingPage from "../../../assets/WebsiteBuilder/landingPage.jpg";
import landingPage2 from "../../../assets/WebsiteBuilder/landingPage2.jpg";
import landingPage3 from "../../../assets/WebsiteBuilder/landingPage3.jpg";
import landingPage4 from "../../../assets/WebsiteBuilder/landingPage4.jpg";
import landingPage5 from "../../../assets/WebsiteBuilder/landingPage5.jpg";

const TemplateCardsData = [
    {
        banner: landingPage,
        title: "Minimal",
        label: "Popular",
        desc: "Clean and simple design with lots of whitespace",
        tabs: ["Clean Design", "Minimal Layout", "Easy Reading"],
    },
    {
        banner: landingPage2,
        title: "Modern Grid",
        label: "Premium",
        desc: "Contemporary grid-based layout",
        tabs: ["Grid Layout", "Modern UI", "Responsive Design"],
    },
    {
        banner: landingPage3,
        title: "Elegant Dark",
        label: "Modern",
        desc: "Clean and simple design with lots of whitespace",
        tabs: ["Clean Design", "Minimal Layout", "Easy Reading"],
    },
    {
        banner: landingPage4,
        title: "Minimal",
        label: "Popular",
        desc: "Clean and simple design with lots of whitespace",
        tabs: ["Clean Design", "Minimal Layout", "Easy Reading"],
    },
    {
        banner: landingPage5,
        title: "Modern Grid",
        label: "Premium",
        desc: "Contemporary grid-based layout",
        tabs: ["Grid Layout", "Modern UI", "Responsive Design"],
    },
];

const WebsiteBuilders = () => {
    return (
        <StyledWebsiteBuilders>
            <h2 className="title">Create Your Restaurant Website</h2>
            <div className="desc">
                Choose a beautiful template and launch your professional restaurant website in just 2 minutes
            </div>
            <div className="head">
                <strong className="label">Choose Your Template</strong>
                <span className="para">Select a design that matches your restaurant's personality</span>
            </div>
            <div className="template-cards-wrap">
                {TemplateCardsData?.map((data, index) => (
                    <TemplateCard data={data} key={index} />
                ))}
            </div>
        </StyledWebsiteBuilders>
    );
};

export default WebsiteBuilders;
